const STOREFRONT_API_VERSION = '2024-01';

function getGate() {
  return document.querySelector('.doctor-gate');
}

function getModal() {
  return document.getElementById('doctor-modal');
}

function openModal(tab) {
  const modal = getModal();
  if (!modal) return;
  modal.showModal();
  document.body.style.overflow = 'hidden';
  switchTab(tab ?? 'register');
}

function closeModal() {
  const modal = getModal();
  if (modal) modal.close();
  document.body.style.overflow = '';
}

function switchTab(tabName) {
  const modal = getModal();
  if (!modal) return;
  modal.querySelectorAll('[data-doctor-tab]').forEach((btn) => {
    const active = btn.dataset.doctorTab === tabName;
    btn.classList.toggle('doctor-modal__tab--active', active);
    btn.setAttribute('aria-selected', active ? 'true' : 'false');
  });
  modal.querySelectorAll('.doctor-modal__panel').forEach((panel) => {
    panel.classList.toggle('doctor-modal__panel--active', panel.id === `doctor-panel-${tabName}`);
  });
}

function validateForm(form) {
  let valid = true;

  form.querySelectorAll('[data-field]').forEach((fieldEl) => {
    const input = fieldEl.querySelector('input, select');
    if (!input) return;
    const fieldValid = input.checkValidity();
    fieldEl.classList.toggle('has-error', !fieldValid);
    if (!fieldValid) valid = false;
  });

  return valid;
}

async function storefrontFetch(shop, token, query, variables) {
  const res = await fetch(`https://${shop}/api/${STOREFRONT_API_VERSION}/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': token,
    },
    body: JSON.stringify({ query, variables }),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

async function createCustomer(shop, token, { firstName, lastName, email, password }) {
  const { data, errors } = await storefrontFetch(shop, token, `
    mutation customerCreate($input: CustomerCreateInput!) {
      customerCreate(input: $input) {
        customer { id email }
        customerUserErrors { code field message }
      }
    }
  `, { input: { firstName, lastName, email, password, acceptsMarketing: true } });

  if (errors?.length) throw new Error(errors[0].message);
  const { customerUserErrors } = data.customerCreate;
  if (customerUserErrors.length) throw new Error(customerUserErrors[0].message);
  return data.customerCreate.customer;
}


async function writeDoctorData(workerUrl, workerKey, { customerId, rpps, specialty, phone, clinic, address }) {
  const res = await fetch(workerUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Worker-Key': workerKey,
    },
    body: JSON.stringify({ customerId, rpps, specialty, phone, clinic, address }),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error ?? `Worker error ${res.status}`);
  }
}

function showGlobalError(msg) {
  const el = document.getElementById('doctor-register-error');
  if (!el) return;
  el.textContent = msg;
  el.classList.add('is-visible');
}

function hideGlobalError() {
  document.getElementById('doctor-register-error')?.classList.remove('is-visible');
}

async function handleRegisterSubmit(e) {
  e.preventDefault();
  const form = e.target;
  hideGlobalError();
  if (!validateForm(form)) return;

  const gate = getGate();
  if (!gate) {
    submitBtn.disabled = false;
    submitBtn.textContent = 'Envoyer ma demande';
    showGlobalError("Erreur de configuration. Veuillez recharger la page.");
    return;
  }
  const shop = gate.dataset.shop;
  // Public Storefront API token — unauthenticated_write_customers scope only, intentionally visible in DOM
  const storefrontToken = gate.dataset.storefrontToken;
  const workerUrl = gate.dataset.workerUrl;
  const workerKey = gate.dataset.workerKey;

  const val = (name) => form.querySelector(`[name="${name}"]`)?.value?.trim() ?? '';

  const submitBtn = document.getElementById('doctor-register-submit');
  submitBtn.disabled = true;
  submitBtn.textContent = 'Envoi en cours…';

  try {
    const customer = await createCustomer(shop, storefrontToken, {
      firstName: val('first_name'),
      lastName: val('last_name'),
      email: val('email'),
      password: val('password'),
    });

    await writeDoctorData(workerUrl, workerKey, {
      customerId: customer.id,
      rpps: val('rpps'),
      specialty: val('specialty'),
      phone: val('phone'),
      clinic: val('clinic'),
      address: val('address'),
    });

    form.hidden = true;
    const successEl = document.getElementById('doctor-register-success');
    const emailSpan = document.getElementById('doctor-success-email');
    if (emailSpan) emailSpan.textContent = val('email');
    if (successEl) successEl.hidden = false;
  } catch (err) {
    submitBtn.disabled = false;
    submitBtn.textContent = 'Envoyer ma demande';
    const raw = err instanceof Error ? err.message : String(err);
    const msg = raw.includes('CUSTOMER_DISABLED') || raw.toLowerCase().includes('taken')
      ? 'Un compte existe déjà avec cet email.'
      : `Erreur lors de l'inscription : ${raw}`;
    showGlobalError(msg);
  }
}

function init() {
  const gate = getGate();
  if (!gate) return;

  document.querySelectorAll('[data-doctor-modal-open]').forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      openModal(trigger.dataset.doctorModalTab ?? 'register');
    });
  });

  const modal = getModal();
  if (modal) {
    modal.querySelector('[data-doctor-modal-close]')?.addEventListener('click', closeModal);
    modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });
    modal.addEventListener('close', () => { document.body.style.overflow = ''; });
    modal.querySelectorAll('[data-doctor-tab]').forEach((btn) => {
      btn.addEventListener('click', () => switchTab(btn.dataset.doctorTab));
    });
  }

  document.getElementById('doctor-register-form')?.addEventListener('submit', handleRegisterSubmit);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
